/**
 * FJERNHJELP (A11, 270.1 a, 270.2 b; migrering 1031).
 *
 * Plattformadmin trykker «Gå inn som support» på organisasjonen i Control Room og skriver en grunn.
 * Det gir et tidsbegrenset medlemskap med superadmin-rettigheter, merket support (standard 2 timer),
 * som utløper av seg selv eller med «Gå ut» i båndet øverst. Alt som endres, står i organisasjonens
 * egen endringslogg med den ekte brukeren og «(support)». Kunden varsles ikke (270.2 b).
 */
import { z } from 'zod';

export const SUPPORT_DEFAULT_MINUTES = 120;
export const SUPPORT_MIN_MINUTES = 15;
export const SUPPORT_MAX_MINUTES = 480;
export const SUPPORT_REASON_MAX = 500;

export const enterSupportRequestSchema = z
  .object({
    /** Hvorfor support går inn. Står i plattformloggen. */
    reason: z.string().trim().min(3).max(SUPPORT_REASON_MAX),
    minutes: z
      .number()
      .int()
      .min(SUPPORT_MIN_MINUTES)
      .max(SUPPORT_MAX_MINUTES)
      .default(SUPPORT_DEFAULT_MINUTES),
  })
  .meta({ id: 'EnterSupportRequest' });
export type EnterSupportRequest = z.infer<typeof enterSupportRequestSchema>;

export const supportSessionSchema = z
  .object({
    organizationId: z.uuid(),
    /** Når supportmedlemskapet utløper. */
    supportUntil: z.iso.datetime(),
  })
  .meta({ id: 'SupportSession' });
export type SupportSession = z.infer<typeof supportSessionSchema>;
